import { useState } from "react";
import { getCourses } from "../../service/BundleService";


export const useCourses = () => {
  const [courseList, setCourseList] = useState([]);
  const [error, setError] = useState(null);

 const fetchCourses = async () => {
    const result = await getCourses();
    
    if (result?.success) {
      const courses = result.data.map((course) => ({
        value: course.courseId,
        label: course.title,
      }));
      setCourseList(courses);
      setError(null);
    } else {
      console.error("Error fetching courses:", result?.data);
      setCourseList([]);
      setError(result?.data);
    }
  };

  return {
    courseList,
    error,
    fetchCourses,
  };
};